<template>
  <lpopup
    class="vfilter"
    :class="{ daterange: type === 'date' }"
    width="300px"
    :wrapper_selector="wrapper_selector"
    @hide="$emit('cancel')"
  >
    <!-- TYPE - LIST -->
    <div v-if="type === 'list'">
      <div ref="list_block" class="vfilter_scroll">
        <vinput
          v-if="search"
          ref="vfilter_input"
          v-model="keyword"
          class="vfilter_search"
          border
          icon="search"
          :placeholder="input_placeholder"
        />

        <div class="items_list">
          <div v-if="search" class="items_list_row">
            <vcheckbox class="items_list_checkbox" :value="select_all" @input="toggle_selected_all" />

            <div class="items_list_name" @click.prevent.stop="toggle_selected_all">
              {{ $tr(keyword.length === 0 ? 'filter.list.select_all' : 'filter.list.select_searched', locale) }}
            </div>
          </div>

          <div v-for="item in items" :key="item.id" class="items_list_row">
            <vcheckbox
              class="items_list_checkbox"
              :value="~selected_list.indexOf(item.id)"
              @input="toggle_selected(item.id)"
            />

            <div class="items_list_name" @click.prevent.stop="toggle_selected(item.id)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="controls">
        <div class="controls__left">
          <vbutton class="controls_button" size="small" label="common.done" @click="$emit('apply')" />

          <vbutton size="small" class="controls_button" label="actions.cancel" color="grey" @click="$emit('cancel')" />
        </div>

        <div v-tooltip.top="$tr('filter.clear')" class="filter_clear" @click="$emit('clear')">
          <i class="icon icon-filter_clear"></i>
        </div>
      </div>
    </div>

    <!-- TYPE - DATE -->
    <div v-else-if="type === 'date'">
      <template v-if="is_days_disabled_start">
        <date-range
          class="vcalendar"
          :sync-range.sync="range"
          :lang="locale"
          :first-day-of-week="1"
          :emit-change-on-step0="true"
          :days-disabled-start="future_date"
          :month-year-format="dateFormatPicker"
        />
      </template>

      <template v-else>
        <date-range
          class="vcalendar"
          :sync-range.sync="range"
          :lang="locale"
          :first-day-of-week="1"
          :emit-change-on-step0="true"
          :month-year-format="dateFormatPicker"
        />
      </template>

      <div class="controls">
        <div class="controls__left">
          <vbutton size="small" class="controls_button" :label="$tr('common.done', locale)" @click="$emit('apply')" />

          <vbutton
            size="small"
            class="controls_button"
            :label="$tr('common.cancel', locale)"
            color="grey"
            @click="$emit('cancel')"
          />
        </div>

        <div v-tooltip.top="$tr('filter.clear')" class="filter_clear" @click="$emit('clear')">
          <i class="icon icon-filter_clear"></i>
        </div>
      </div>
    </div>

    <!-- TYPE - TEXT -->
    <div v-else-if="type === 'text'">
      <vinput
        v-if="search"
        ref="vfilter_input"
        v-model="keyword"
        class="vfilter_search"
        border
        :placeholder="input_placeholder"
        icon="search"
        @input="updateKeyword"
      />
      <div class="controls">
        <div class="controls__left">
          <vbutton size="small" class="controls_button" label="common.done" @click="$emit('apply')" />

          <vbutton size="small" class="controls_button" label="actions.cancel" color="grey" @click="$emit('cancel')" />
        </div>

        <div v-tooltip.top="$tr('filter.clear')" class="filter_clear" @click="$emit('clear')">
          <i class="icon icon-filter_clear"></i>
        </div>
      </div>
    </div>

    <!-- TYPE - PHONE -->
    <div v-else-if="type === 'phone'">
      <vphone
        v-if="search"
        ref="vfilter_input"
        v-model="keyword"
        class="vfilter_search"
        :class="{ error: !phone_valid }"
        border
        :placeholder="input_placeholder"
        icon="search"
        @input="updateKeyword"
        @valid="phone_valid = $event"
      />
      <div class="controls">
        <div class="controls__left">
          <vbutton
            size="small"
            class="controls_button"
            label="common.done"
            :disabled="!phone_valid"
            @click="$emit('apply')"
          />

          <vbutton size="small" class="controls_button" label="actions.cancel" color="grey" @click="$emit('cancel')" />
        </div>

        <div v-tooltip.top="$tr('filter.clear')" class="filter_clear" @click="$emit('clear')">
          <i class="icon icon-filter_clear"></i>
        </div>
      </div>
    </div>
  </lpopup>
</template>

<script>
import { DateRange } from 'vue-date-range';

export default {
  name: 'Vtfilter',

  components: {
    DateRange
  },

  props: {
    type: {
      type: String,
      default: 'list'
    },

    list: {
      type: Array,
      default: () => []
    },

    selected_list: {
      type: Array,
      default: () => []
    },

    dates: {
      type: Array,
      default: () => []
    },

    input_placeholder: {
      type: String,
      default: ''
    },

    search: {
      type: Boolean,
      default: true
    },

    wrapper_selector: {
      type: String,
      default: ''
    },

    lang: {
      type: String,
      default: ''
    },

    is_days_disabled_start: {
      type: Boolean,
      default: true
    },

    filter_name: {
      type: String,
      default: ''
    },

    textValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      keyword: '',
      step: 100,
      list_count: 100,
      phone_valid: false
    };
  },

  computed: {
    future_date() {
      let d = new Date(Date.now());
      d = d.setDate(d.getDate() + 1);
      return this.$moment(d);
    },

    select_all() {
      if (this.keyword.length > 0) {
        let result = true;
        this.items.forEach(i => {
          if (this.selected_list.indexOf(i.id) === -1) {
            result = false;
          }
        });
        return result;
      } else {
        return this.selected_list.length === this.list.length;
      }
    },

    items() {
      return [...this.list]
        .filter(i => ~i.name.toLocaleLowerCase().indexOf(this.keyword.toLocaleLowerCase()))
        .splice(0, this.list_count);
    },

    range: {
      get() {
        return {
          startDate: this.$moment(this.dates[0]),
          endDate: this.$moment(this.dates[1])
        };
      },

      set(v) {
        this.$emit('input', {
          result: [v.startDate.format('YYYY-MM-DD'), v.endDate.format('YYYY-MM-DD')]
        });
      }
    },

    locale() {
      if (this.lang) {
        return this.lang;
      }

      return this.$store.state.locale.value;
    },

    dateFormatPicker() {
      return this.locale === 'ja' ? 'YYYY - MM' : 'MM - YYYY';
    }
  },

  mounted() {
    if (this.type === 'list') {
      this.$refs.list_block.addEventListener('scroll', e => {
        if (this.list_count < this.list.length) {
          let el = e.target;
          if (el.scrollHeight - el.scrollTop <= el.clientHeight + 20) {
            this.list_count = this.list_count + this.step;
          }
        }
      });
    }

    if ((this.type === 'text' || this.type === 'phone') && this.textValue) {
      this.keyword = this.textValue;
    }
  },

  methods: {
    updateKeyword() {
      this.$emit('input', this.keyword);
    },

    toggle_selected(id) {
      // выкидываем наверх массив выбранных, сюда ожидаем весь список элементов с котырыми работаем
      let pos = this.selected_list.indexOf(id);
      let result = [...this.selected_list];
      if (~pos) {
        // проверяем есть ли в массиве элемент, если есть то выполнится условие
        result.splice(pos, 1);
      } else {
        result.push(id);
      }
      this.$emit('input', {
        result,
        params: {
          name: this.filter_name
        }
      });
    },

    toggle_selected_all() {
      let result = [];
      if (!this.select_all) {
        if (this.keyword.length > 0) {
          result = this.items.map(i => i.id);
          // добавляем в массив result текушие выбранные concat удаляем дубли и возвращаем в массив
          result = [...new Set(result.concat(this.selected_list))];
        } else {
          result = this.list.map(i => i.id);
        }
      } else {
        if (this.keyword.length > 0) {
          result = this.selected_list.filter(i => this.items.map(e => e.id).indexOf(i) === -1);
        }
      }
      this.$emit('input', {
        result: result,
        params: {
          isSelectAll: !!result.length && !this.keyword.length,
          name: this.filter_name
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vfilter {
  padding: 20px;
  cursor: default;
  white-space: normal !important;
  z-index: 999;
  box-shadow: $box-shadow;
  border: 1px solid $grey-light;
  border-radius: 5px;

  &.daterange {
    padding: 15px 20px 15px 20px;
  }

  .vfilter_scroll {
    max-height: 330px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .vfilter_search {
    margin-bottom: 20px;
  }

  .items_list {
    .items_list_row {
      display: flex;
      margin-bottom: 13px;

      &:last-child {
        margin-bottom: 0;
      }

      .items_list_checkbox {
        margin-top: 1px;
        margin-right: 12px;
      }

      .items_list_name {
        @include mixin-text-main;
        flex: 1;
        box-sizing: border-box;
        max-width: 100%;
        cursor: pointer;
      }
    }
  }

  .controls {
    display: flex;
    margin-top: 15px;
    align-items: center;
    justify-content: space-between;

    &__left {
      display: flex;
    }

    .controls_button {
      margin-right: 5px;
    }

    .filter_clear {
      font-size: 18px;
      height: 32px;
      width: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      cursor: pointer;

      i {
        margin: 0;
        transition: color 0.3s;
      }

      &:hover {
        i {
          color: $green-hover;
          transition: color 0.3s;
        }
      }
    }
  }

  ::v-deep {
    .v-date-calendar .v-date-wrapper .v-date-days {
      display: flex;
      flex-wrap: wrap;
    }
    .v-date-day-cell {
      flex: 1 0 14.28%;
    }
  }

  .vfilter_search.error {
    margin-top: 0;
  }
}
</style>
